const n = () => typeof window < "u" && "electron" in window;
export {
  n as isElectron
};
